{
  "deprecatedBrowser": "Su explorador no es compatible",
  "deprecatedBrowserHelpText": "Le recomendamos actualizar su navegador a la versión más reciente para garantizar la mejor experiencia."
}
